<div class="padding">
	<b>{{ title }}</b>

	@if (!loading && articleResumees.length) {
		<div class="margin-top-small scrollable">
			<table class="min-width">
				<tr>
					<th>Warehouse</th>
					<th>Color</th>
					<th>Sizes</th>
				</tr>

				@for (row of articleResumees; track row.warehouse?.id + '-' + row.color?.id) {
					<tr>
						<td>{{ row.warehouse?.label }}</td>
						<td>{{ row.color?.label }}</td>
						<td>
							<div class="flex wrap">
								@for (size of row.sizes; track size.id) {
									<div class="margin-right-smallest bg-light-grey padding-smallest radius">{{ size.label }}</div>
								}
							</div>
						</td>
					</tr>
				}
			</table>
		</div>
	}

	@if (!loading && !articleResumees.length) {
		<div class="margin-top-small padding-small bg-light-grey flex center justify-center">No warehouses available</div>
	}

	<div class="flex column end margin-top">
		<button class="stroked" (click)="close()">
			<i class="fa-solid fa-undo"></i>
			Close
		</button>
	</div>
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
